import NotFoundComponent from '@sportnet/ui/lib/NotFound';
import React from 'react';
import { Helmet } from 'react-helmet';
import EntryAnimation from '../../components/EntryAnimation';
import { CenteredContentWrapper, PageWrapper } from '../../components/Layout';
import __ from '../../utilities/__';
import Footer from '../Footer';

const NotFound: React.FC<{}> = () => {
  return (
    <PageWrapper>
      <Helmet>
        <title>{__('Stránka neexistuje')}</title>
      </Helmet>
      <CenteredContentWrapper>
        <EntryAnimation key={'not-found'}>
          <NotFoundComponent title={__('Stránka neexistuje')} icon="error" />
        </EntryAnimation>
      </CenteredContentWrapper>
      <Footer />
    </PageWrapper>
  );
};

export default NotFound;
